exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-primary {\n  width: 100%; }\n\n.btn-cancel {\n  width: 100%; }\n\n.modal-title {\n  margin-bottom: 0 !important;\n  font-size: 16px !important;\n  font-weight: 500; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/shared/dialog-modal/dialog-modal.component.scss
// module id = ../../../../../src/app/shared/dialog-modal/dialog-modal.component.scss
// module chunks = main